import type { SvgProps } from 'react-native-svg';
import Svg, { Path } from 'react-native-svg';

export const ArrowDown = ({
  color,
  fill,
  stroke,
  width = 10,
  height = 12,
  ...props
}: SvgProps) => {
  const lineColor = stroke ?? color ?? fill;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 10 12"
      fill="none"
      {...props}
    >
      <Path
        d="M5 1.25V7.75M2.75 5.75L5 8.25L7.25 5.75"
        stroke={lineColor}
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
